module.exports = __webpack_public_path__ + "img/scan.a57522de.svg";